



















































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import { eventBus } from '@/main';
import { APP_CONFIG } from '@/config/app-config';
import authService from '@/services/auth-services';
import creditServices from '@/services/credit-services';
const numeral = require('numeral');
@Component({
    components: {
        Loading
    }
})
export default class Withdrawal extends Vue {

    @Prop({default: null})
    private onWithDrawal!: boolean;

    private withdrawalModel = {
        withDrawValue: 0,
        bank: '',
        bankOwner: '',
        bankNumber: '',
        description: ''
    };
    private isLoading = false;

    get customerInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].customerInfo;
    }

    @Watch('onWithDrawal', { immediate: true, deep: true })
    private watchOnWithDrawal() {
        this.withDrawal();
    }

    private async getCustomersInfo() {
        const result = await authService.customersInfo(this.customerInfo.ID);
        if(result && result.status === 200) {
            (window['getApp'] as any).$emit('APP_SET_CUSTOMER_INFO', result.data.data || {});
        }
    }

    private async withDrawal() {
        try {
            const isValid = await (this.$refs['observer'] as any).validate();
            if (isValid) {
                if(this.customerInfo.Wallet < numeral(this.withdrawalModel.withDrawValue).value()) {
                    Vue.notify({
                        group: 'foo',
                        type: 'error',
                        title: 'Thông báo!',
                        text: 'Không thể rút nhiều hơn số dư ví.',
                    });
                    return;
                }

                this.isLoading = true;

                const dataRequest = {
                    Amount: numeral(this.withdrawalModel.withDrawValue).value(),
                    Bank: this.withdrawalModel.bank,
                    BankAccountNumber: this.withdrawalModel.bankNumber,
                    BankAccountName: this.withdrawalModel.bankOwner,
                    Note: this.withdrawalModel.description
                };

                const result = await creditServices.submitWithdrawal(dataRequest);

                if (result && result.status === 200 && result.data.message === 'Success') {
                    Vue.notify({
                        group: 'foo',
                        type: 'success',
                        title: 'Thông báo!',
                        text: 'Tạo lệnh rút tiền thành công!',
                    });
                    this.withdrawalModel = {
                        withDrawValue: 0,
                        bank: '',
                        bankOwner: '',
                        bankNumber: '',
                        description: ''
                    };
                    eventBus.$emit(APP_CONFIG.eventBusAction.reloadWithdrawalHistories);
                } else {
                    Vue.notify({
                        group: 'foo',
                        type: 'error',
                        title: 'Thông báo!',
                        text: 'Tạo lệnh rút tiền thất bại!',
                    });
                }
                await this.getCustomersInfo();
                this.isLoading = false;
            }
        } catch {
            return false;
        }
    }
}
